import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  label_name: "",
  drawerLevel1Id: "",
  drawerLevel2Id: "",
  drawerLevel3Id: "",
  drawerLevel4Id: "",
  currentModuleId: 0,
  defaultModule: 6,
  user_name: "",
  doctorId: "",
};

export const appStateSlice = createSlice({
  name: "appStateReducer",
  initialState,
  reducers: {
    resetAppState: (state, action) => {
      return {
        ...initialState,
      };
    },

    changeLoggedInStatus: (state, action) => {
      state.isLoggedIn = action.payload.isLoggedIn;
      state.userToken = action.payload.userToken;
      state.onlyDeliveryPartner = action.payload.onlyDeliveryPartner;
      state.user_id = action.payload.user_id;
      state.user_name = action.payload.user_name;
      state.sysAdmin = action.payload.sysAdmin;
      state.email = action.payload.email;
      state.user_group_id = action.payload.user_group_id;
      state.doctorId = action.payload.doctorId;
    },
    setUserToken: (state, action) => {
      state.token = action.payload;
    },
    setLabelName: (state, action) => {
      state.label_name = action.payload;
    },
    setDrawerLevel1: (state, action) => {
      state.drawerLevel1Id = action.payload;
    },
    setDrawerLevel2: (state, action) => {
      state.drawerLevel2Id = action.payload;
    },
    setDrawerLevel3: (state, action) => {
      state.drawerLevel3Id = action.payload;
    },
    setDrawerLevel4: (state, action) => {
      state.drawerLevel4Id = action.payload;
    },
    setCurrentModuleId: (state, action) => {
      state.currentModuleId = action.payload;
    },
    setDefaultModuleId: (state, action) => {
      state.defaultModule = action.payload;
    },
    setUserName: (state, action) => {
      state.user_name = action.payload;
    },
  },
});

export const {
  resetAppState,
  setUserToken,
  setLabelName,
  setDrawerLevel1,
  setDrawerLevel2,
  setDrawerLevel3,
  setDrawerLevel4,
  setCurrentModuleId,
  setDefaultModuleId,
  setUserName,
  changeLoggedInStatus,
} = appStateSlice.actions;

export default appStateSlice.reducer;
